import { Form, Input } from "antd";
import React from "react";

import { useController } from "react-hook-form";
import { checkHookFormFieldPropsEquality } from "../formValidatonRules";

const CustomInputTextArea = (props) => {
  const {
    field,
    fieldState: { error, isTouched, isDirty },
  } = useController({
    name: props.name,
    control: props.control,
  });

  return (
    <Content
      {...props}
      field={field}
      error={error}
      isTouched={isTouched}
      isDirty={isDirty}
    />
  );
};

const Content = React.memo((props) => {
  const { field, error } = props;

  var inputProps = { ...props };
  delete inputProps.control;
  delete inputProps.formLabel;
  delete inputProps.layout;
  delete inputProps.required;
  delete inputProps.isTouched;
  delete inputProps.isDirty;
  delete inputProps.error;
  delete inputProps.field;

  return (
    <Form.Item
      {...props.layout}
      label={props.formLabel}
      name={props.name}
      validateStatus={error != null ? "error" : ""}
      help={error != null ? error.message : null}
      required={props.required}
    >
      <div>
        <Input.TextArea {...field} {...inputProps} />
      </div>
    </Form.Item>
  );
}, checkHookFormFieldPropsEquality);
export default CustomInputTextArea;
